// This file is generated do not modify manually
export const miscellaneous = [
    { path: 'Contact', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'ExchangeRates', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'BlockAccount', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'TravelNotice', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'LinkCreditCard', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'AccountsBanner', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'ActivateTextBanking', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'LinkAtmCard', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'RequestApp', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'ATMPINCode', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'BlockBankCard', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'OverdraftList', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'ManageMobileDevices', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'Mashup', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
    { path: 'NewAccount', loadChildren: () =>
    import('./miscellaneous.module').then(m => m.MiscellaneousModule) },
];
